import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The personal integrations page moved into settings (`/settings/integrations`),
 * next to the other things a user manages for themselves. This route stays as a
 * redirect: it shipped, so it is in bookmarks and in links already written, and
 * it carries the OAuth `?code&state` hop forward untouched.
 */
export const Route = createFileRoute("/_authenticated/dashboard/integrations")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/integrations", search: true });
	},
});
